import ICheckableGroup from '@inkline/inkline/src/components/ICheckableGroup';
import IButtonGroup from '@inkline/inkline/src/components/IButtonGroup';

export default {
    name: 'IRadioButtonGroup',
    extends: ICheckableGroup,
    components: {
        IButtonGroup
    }
};
